module.exports = __webpack_public_path__ + "img/menu-burger-gri.d20e88bc.svg";